import * as React from 'react'
import CX from 'classnames'
import { Intent, Slider } from '@blueprintjs/core'

interface Props {
  formLoading: boolean
  requiredFieldCount: number
  missingRequiredFields: any[]
  topRightElement?: React.ReactNode
  style?: unknown
}

export const ProgressBar: React.FC<Props> = props => {
  const { formLoading, requiredFieldCount, missingRequiredFields, topRightElement } = props

  const completedFieldCount = requiredFieldCount - missingRequiredFields.length
  const requiredFieldsDone = completedFieldCount === requiredFieldCount

  let sliderValue = completedFieldCount
  // It's subtle, but show a tiny bit of blue bar when they have 1 field filled out.
  // Otherwise the progress bar for 1 looks the same as 0
  if (sliderValue === 1) sliderValue = 1.2

  return (
    <div className={CX('progress-bar', formLoading && 'bp5-skeleton')} style={props.style}>
      <div className="progress-bar-top">
        <small className={CX('progress-label', requiredFieldsDone && 'success')}>
          {requiredFieldsDone ? 'Done' : `${completedFieldCount} of ${requiredFieldCount} complete`}
        </small>
        {topRightElement || <span />}
      </div>
      <Slider
        min={1}
        max={requiredFieldCount}
        value={sliderValue}
        intent={requiredFieldsDone ? Intent.SUCCESS : Intent.PRIMARY}
        labelRenderer={(value: number) => {
          if (value === 1) return value.toString()
          if (value === requiredFieldCount) return value.toString()
          return '•'
        }}
      />
    </div>
  )
}
